<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="bullseye"/>
          {{ $t('setupKPI') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          placeholder="mm/yyyy"></b-form-input>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-sorting" v-if="['owner','admin', 'operationsManager'].includes($store.state.user.role)" >
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-3">{{ $t('time') }}</div>
            <div class="col-lg-5">{{ $t('info') }}</div>
            <div class="col-lg-4"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-3">
              <div> 
                <div>
                  <b class="c-smart-table__label">{{ $t('time') }}: </b>
                  {{ !(item.month > 9) ? '0' + item.month : item.month }}/{{ item.year }}
                </div>
              </div>
            </div>
            <div class="col-lg-5">
              <div>
                <b>{{$t('createdBy')}}: </b> {{item.createdBy.name}}
              </div>
              <div>
                <b>{{$t('createdAt')}}: </b> {{item.createTime | moment('DD/MM/YYYY HH:mm:ss')}}
              </div>
              <div v-if="item.updatedBy">
                <b>{{$t('updatedBy')}}: </b> {{item.updatedBy.name}}
              </div>
              <div v-if="item.updateTime && item.updateTime != item.createTime">
                <b>{{$t('updatedAt')}}: </b> {{item.updateTime | moment('DD/MM/YYYY HH:mm:ss')}}
              </div>
            </div>
            <div class="col-lg-4">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col">
                    <kpi-list type="bd" :kpi="item" @change="load"></kpi-list>
                    <kpi-list type="am" :kpi="item" @change="load"></kpi-list>
                    <!-- <button @click="del(item._id)" type="button" v-if="['owner','admin'].includes($store.state.user.role)"
                      class="btn btn-sm btn-danger mr-1">
                      <font-awesome-icon icon="trash" />&nbsp;{{ $t('delete') }}
                    </button> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>

      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
      <form-input :label="$t('month')" :model="formModel" attribute="month" :errors="formErrors"></form-input>
      <form-input :label="$t('year')" :model="formModel" attribute="year" :errors="formErrors"></form-input>
    </b-modal>
  </main>
</template>

<script>
import List from "@/mixins/List";
import CRUD from "@/mixins/CRUD";
import KPIList from "@/views/account/KPIList";

export default {
  components: {
    'kpi-list': KPIList
  },
  mixins: [List, CRUD],
  data: function () {
    return {
      autoLoad: true,
      service: '/admin-user-kpi',
      defaultFormModel: {
        type: "other",
        keyword: null
      }
    }
  },
  i18n: {
    messages: {
      en: {
        setupKPI: "Setup KPI",
        month: "Month",
        year: "Year",
        createdBy: "Created by",
        createdAt: "Created at",
        updatedBy: "Updated by",
        updatedAt: "Updated at",
      },
      vi: {
        setupKPI: "Cài đặt KPI",
        month: "Tháng",
        year: "Năm",
        createdBy: "Tạo bởi",
        createdAt: "Tạo lúc",
        updatedBy: "Cập nhật bởi",
        updatedAt: "Cập nhật lúc",
      }
    }
  }
};
</script>